var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.gallery.length > 0)?_c('section',{staticClass:"project-gallery"},[_c('h2',[_vm._v(_vm._s(_vm.$t('project.gallery')))]),_c('photo-swipe-gallery',{staticClass:"mt-5",attrs:{"items":_vm.gallery}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }